// Main export file
import InspectorDashboard from './InspectorDashboard';

export default InspectorDashboard;

// Export other components for potential use in other parts of the application
export { default as DashboardStats } from './DashboardStats';
export { default as SearchControls } from './SearchControls';
export { default as InspectionCard } from './InspectionCard';
export { default as ListView } from './ListView';
export { default as CalendarView } from './CalendarView';
export { default as CompletedView } from './CompletedView';
export { default as CompletionDialog } from './CompletionDialog';
export { default as ActionMenu } from './ActionMenu';

// Export types
export * from './types';